// extracted by mini-css-extract-plugin
export default {"Constructor__title":"MobileView_Constructor__title__2Jrl-"};